import React from "react";

const RupeeSVG: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="47" 
    height="53" 
    viewBox="0 0 47 53" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M1.06543 18.1694C1.06543 18.1694 7.68195 15.053 11.9215 13.0562M45.6431 50.231L17.2531 40.0215C17.2531 40.0215 20.8718 38.3171 23.2843 37.1808C25.6968 36.0445 37.7591 30.3631 32.0777 18.3008C26.3963 6.23851 14.334 11.9199 11.9215 13.0562M34.8399 2.26154C34.8399 2.26154 18.9875 9.7281 11.9215 13.0562M6.74682 30.2318L40.5213 14.3239" 
      stroke="#E53935" 
      strokeOpacity="0.25" 
      strokeWidth="5"
    />
  </svg>
);

const LoanSteps: React.FC = () => {
  const steps = [
    {
      id: 1,
      title: "Apply Online",
      desc: "Complete a quick application with your basic personal details.",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.3" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )
    },
    {
      id: 2,
      title: "Verify Information",
      desc: "Upload your KYC documents securely for instant verification.",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.3" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zm12-2l-3 3-1.5-1.5" />
        </svg>
      )
    },
    {
      id: 3,
      title: "Get Funded",
      desc: "Receive your approved loan directly into your bank account.",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.3" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    }
  ];

  return (
    <section id="how-it-works" className="w-full bg-[#FFF3F3]  py-4 md:py-28 px-6 lg:px-20 flex justify-center relative overflow-hidden">
      
      {/* Floating Background Rupee SVGs */}
      <RupeeSVG className="hidden md:block absolute top-12 left-[12%] w-[42px] h-[48px] pointer-events-none select-none rotate-[15deg] z-0" />
      <RupeeSVG className="hidden md:block absolute top-16 right-[24%] w-[58px] h-[66px] pointer-events-none select-none rotate-[-12deg] z-0" />
      <RupeeSVG className="hidden md:block absolute top-1/2 left-[2%] w-[44px] h-[50px] pointer-events-none select-none rotate-[-25deg] z-0" />
      <RupeeSVG className="hidden md:block absolute bottom-10 right-[8%] w-[40px] h-[46px] pointer-events-none select-none rotate-[35deg] z-0" />

      <div className="max-w-[1400px] w-full flex flex-col relative z-10">
        
        {/* Header Block */}
        <div className="hidden md:flex items-center gap-3 text-neutral-500 uppercase tracking-[0.15em] text-xs md:text-sm font-bold mb-3">
          <span className="w-7 h-[1.5px] bg-neutral-400" />
          <span>How It Works</span>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[50px] font-kualine md:font-sans font-semibold md:font-black leading-[1.15] tracking-tight text-neutral-900 mt-2 text-center md:text-left">
          Three simple steps to
          <span className="block text-[#DE3226] mt-2">get started</span>
        </h2>

        {/* Steps Horizontal Grid */}
        <div className="w-full border-t border-b border-[#E2E8F0] divide-y divide-[#E2E8F0] md:divide-y-0 md:divide-x md:divide-[#E2E8F0] mt-10 md:mt-20 py-0 md:py-14 grid grid-cols-1 md:grid-cols-3">
          {steps.map((step) => (
            <div 
              key={step.id} 
              className="flex items-start justify-between gap-5 px-6 md:px-10 py-6 md:py-0 w-full"
            >
              {/* Text Area */}
              <div className="flex flex-col text-left">
                <h3 className="text-lg md:text-xl lg:text-[22px] font-semibold text-neutral-800 leading-snug">
                  {step.title}
                </h3>
                <p className="text-neutral-900 text-sm md:text-[14.5px] font-light leading-relaxed mt-2.5 max-w-[280px]">
                  {step.desc}
                </p>
              </div>

              {/* Icon Area */}
              <div className="text-[#DE3226] bg-[#DE3226]/8 p-3 rounded-[12px] shrink-0 shadow-[0_2px_8px_rgba(222,50,38,0.02)]">
                {step.icon}
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default LoanSteps;
